/**
 * @generated SignedSource<<c7a6d6106dbe8aa2fcb55a0ba9933676>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionsHistoryQuery$variables = {
  after?: string | null;
  first?: number | null;
  routineId: string;
  workspaceId: string;
};
export type WorkspaceRoutineOccasionsHistoryQuery$data = {
  readonly routine: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionsHistoryList_Routine">;
  } | null;
};
export type WorkspaceRoutineOccasionsHistoryQuery = {
  response: WorkspaceRoutineOccasionsHistoryQuery$data;
  variables: WorkspaceRoutineOccasionsHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceRoutineOccasionsHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceRoutineOccasionsHistoryList_Routine"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceRoutineOccasionsHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "RoutineWorkspaceOccasionConnection",
            "kind": "LinkedField",
            "name": "workspaceOccasions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineWorkspaceOccasionEdgeE",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineWorkspaceOccasion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sequenceNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "storesCompletedCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "storesCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "issueCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "filters": [
              "workspaceId"
            ],
            "handle": "connection",
            "key": "WorkspaceRoutineOccasionsHistoryList_workspaceOccasions",
            "kind": "LinkedHandle",
            "name": "workspaceOccasions"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a4ed2900508ceb3783256e8599f91295",
    "id": null,
    "metadata": {},
    "name": "WorkspaceRoutineOccasionsHistoryQuery",
    "operationKind": "query",
    "text": "query WorkspaceRoutineOccasionsHistoryQuery(\n  $routineId: ID!\n  $first: Int\n  $after: String\n  $workspaceId: ID!\n) {\n  routine(id: $routineId) {\n    id\n    ...WorkspaceRoutineOccasionsHistoryList_Routine\n  }\n}\n\nfragment WorkspaceRoutineOccasionsHistoryList_Routine on Routine {\n  id\n  workspaceOccasions(first: $first, after: $after, workspaceId: $workspaceId) {\n    edges {\n      node {\n        id\n        startAt\n        sequenceNumber\n        storesCompletedCount\n        storesCount\n        issueCount\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b7949fdb39d65a566078add6b4f567d";

export default node;
